(function () {
  /**
   * @ngdoc module
   * @name binky.core.common.member.type
   * @description Module which contains member type related services
   */
  angular.module('binky.core.common.member.type', [
    'binky.core.lodash',
    'binky.core.src2-migration',
  ]);
})();
